module.exports = __webpack_public_path__ + "img/gebratenesschweinefleischohnehintergrund.ed372f73.png";